import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

export const useCheckJoinEligibility = () =>
  useQuery({
    ...curatorQueries.join.checkJoinEligibility({}),
    enabled: false,
  });
